import { FILTER_VALUE_SEPARATOR } from '@aibees/elephant/constants/filters';
import { useSearchQueryFilter } from '@aibees/elephant/hooks';
import { encodeQueryParamValues } from '@aibees/shared/utils';
import { useCallback } from 'react';

export function useAddTagToParam() {
  const { setParam, params } = useSearchQueryFilter();
  const addTagToParam = useCallback(
    (field: string, newTag: string) => {
      const existingValues = params[field]?.split(FILTER_VALUE_SEPARATOR) || [];
      const newValues = [...existingValues];
      if (newTag && !newValues.includes(newTag)) {
        newValues.push(newTag);
      }
      const encodedValue = encodeQueryParamValues(newValues);
      setParam(field, encodedValue);
    },
    [params, setParam]
  );

  return addTagToParam;
}
